import GameScene from "./components/GameScene";


function App() {

  return (
    <GameScene />    
  );
}

export default App;
